<script>
  import { onDestroy, onMount } from "svelte";

  let {
    paperTitle,
    paperAuthors,
    songTitle,
    songArtist,
    lyrics,

    music,

    generationId = null,

    showShareButton = false,
    showDownloadButton = false,

    doubleClick = null,

    // dispatch
    back = null,
  } = $props();


  // Bug while developing with partial page reloads, but this doesn't help.
  onDestroy(() => {
    if (player) {
      player.src = '';
      player.pause();
    }
  });

  let player = $state(null);
  let loading = $state(true);
  let noAudio = $state(false);

  let currentPosition = $state(0);
  let isPaused = $state(true);
  let duration = $state(null);
  let lyricElements = {};

  let volume = $state(localStorage.getItem("volume") !== null ? parseFloat(localStorage.getItem("volume")) : 1.0);

  let lastScrolledElem = null;
  let lyricsMeta = $state({});

  $effect(() => {
    for (const key in lyrics) {
      if (!lyricsMeta[key]) {
        lyricsMeta[key] = {};
      }
      lyricsMeta[key].finished = currentPosition >= lyrics[key].endTime;
      lyricsMeta[key].notStarted = currentPosition < lyrics[key].startTime;      
    }
  });

  let activeLyric = $derived(() => {
    if (!loading && !noAudio) {
      for (const key in lyrics) {
        if (currentPosition >= lyrics[key].startTime && currentPosition < lyrics[key].endTime) {
          return key;
        }
      }
    }
    return null;
  });

  let nextLyric = $derived(() => {
    if (!loading && !noAudio) {
      for (const key in lyrics) {
        if (lyrics[key].endTime >= currentPosition) {
          return key;
        }
      }
    }
    return null;
  });

  $effect(() => {
    const scrollLyricKey = nextLyric();
    const elem = lyricElements[scrollLyricKey];
    if (!isPaused && scrollLyricKey && elem) {
      if (elem != lastScrolledElem) {
        elem.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        lastScrolledElem = elem;
      }
   }
  });

  function formatTime(s, dp = 0) {
    if (s === null) { return '-'; }
    const minutes = Math.floor(s / 60);
    const seconds = (s - minutes * 60).toFixed(dp);
    return `${minutes}:${seconds.padStart(dp > 0 ? dp + 3 : 2, "0")}`;
  }

  function togglePlay() {
    if (isPaused) {
      player.play();
    } else {
      player.pause();
    }
  }

  function seek(position, play = true) {
    player.currentTime = position;
    lastScrolledElem = null
    if (play && isPaused) {
      player.play();
    }
  }

  function handleDoubleClick() {
    if (doubleClick) {
      doubleClick();
    }
  }

  function handleShare() {
    const url = window.location.href;
    navigator.clipboard.writeText(url);
    alert(`Address copied to clipboard`);
  }
  
  function handleDownload() {
    // Concatenate lyrics
    let lyricsText = '';
    lyricsText += `---\n`;
    lyricsText += `paper: ${paperTitle}\n`;
    lyricsText += `authors: ${paperAuthors}\n`;
    lyricsText += `artist: ${songArtist}\n`;
    lyricsText += `song: ${songTitle}\n`;
    lyricsText += `id: ${generationId}\n`;
    lyricsText += `---\n`;
    lyricsText += `\n`;
    lyricsText += `# KaraokAI.tech\n`;
    lyricsText += `\n`;
    for (const key in lyrics) {
      const lyric = lyrics[key];
      lyricsText += `${lyric.text}\n`;
    }
    // Download as .txt file
    const blob = new Blob([lyricsText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${paperTitle} - ${songArtist} - ${songTitle}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

</script>

<div class="container">
  <div class="header">
    <!-- svelte-ignore a11y_consider_explicit_label -->
    <button class="back-button" onclick={() => {
      player.pause();
      player.src = '';
      back()
    }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
      </svg>
    </button>
    <div class="track-info" ondblclick={handleDoubleClick}>
      <div class="paper-name">{paperTitle}</div>
      <div class="track-name">{songArtist} - {songTitle}</div>
    </div>
  </div>

  <div class="lyrics-container">
    {#each Object.entries(lyrics) as [key, lyric]}
      <!-- svelte-ignore a11y_click_events_have_key_events -->
      <!-- svelte-ignore a11y_no_static_element_interactions -->
      <div
        class="lyric-line"
        class:active={key === activeLyric()}
        class:next={key === nextLyric()}
        class:finished={lyricsMeta[key] && lyricsMeta[key].finished}
        class:notStarted={lyricsMeta[key] && lyricsMeta[key].notStarted}
        bind:this={lyricElements[key]}
        onclick={() => seek(lyric.startTime)}
      >
        <div class="timestamp">{formatTime(lyric.startTime)}</div>
        <div class="lyrics-part">
          <span class="text" style={`transition: background-position ${Math.max(0, lyric.endTime - lyric.startTime - 0.2)}s linear;`}>{lyric.text}</span>
          <div class="original">{lyric.original}</div>
        </div>
      </div>
    {/each}
  </div>

  <div class="track-data">
    <div class="controls-container">


    {#if showShareButton}
      <!-- svelte-ignore a11y_consider_explicit_label -->
      <button class="button share-btn" onclick={handleShare}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
          <polyline points="16 6 12 2 8 6" />
          <line x1="12" y1="2" x2="12" y2="15" />
        </svg>
      </button>
    {/if}

    {#if showDownloadButton}
      <!-- svelte-ignore a11y_consider_explicit_label -->
      <button class="button share-btn" onclick={handleDownload}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
          <polyline points="16 8 12 14 8 8" />
          <line x1="12" y1="2" x2="12" y2="15" />
        </svg>
      </button>
    {/if}

      {#each ['audio_singleton'] as audio_singleton (audio_singleton)}
        <audio autoplay
          bind:this={player}
          preload="auto"
          crossorigin="use-credentials"
          onloadeddata={(e) => {
            loading = false;
            // @ts-ignore
            e.target.volume = volume;
            // Attempt autoplay (may fail if no interaction)
            // @ts-ignore
            e.target.play().catch(() => {});
          }}
          ontimeupdate={(e) => {
            // @ts-ignore
            currentPosition = e.target.currentTime;
          }}
          ondurationchange={(e) => {
            // @ts-ignore
            duration = e.target.duration;
          }}
          onplay={() => isPaused = false}
          onpause={() => isPaused = true}
          onended={() => {
            seek(0, false);
          }}
        >
          <source src={music || "data:application/octet-stream,"} type="audio/mpeg" onerror={(e) => { loading = false; noAudio = true; }}/>
        </audio>
      {/each}

      {#if loading}
        <div class="audio-loading">Loading...</div>
      {:else if noAudio}
        <div class="audio-error">Song audio only available at the demo booth - you can still browse the generated lyrics.</div>
      {:else}

        <button class="button play-btn" onclick={() => togglePlay()}>
          {#if isPaused}
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <polygon points="5 3 19 12 5 21 5 3" />
            </svg>
          {:else}
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <rect x="6" y="4" width="4" height="16" />
              <rect x="14" y="4" width="4" height="16" />
            </svg>
          {/if}
        </button>
        <div class="time-control">
          <div class="timer-row">
            <input
              type="range"
              class="position-slider"
              value={currentPosition}
              max={duration}
              onchange={(e) => {
                // @ts-ignore
                seek(parseFloat(e.target.value))
              }}
            />
            <div class="time-display">
              <span class="current-time">
                {formatTime(currentPosition)}
              </span>
              <span class="duration">
                {formatTime(duration)}
              </span>
            </div>
          </div>
        </div>
        <div class="volume-control">
          <div class="volume-row">
            <input
              type="range"
              min="0"
              max="100"
              class="position-slider"
              value={Math.floor(volume * 100)}
              onchange={
                (e) => {
                  // @ts-ignore
                  volume = parseFloat(e.target.value) / 100;
                  player.volume = volume;
                  localStorage.setItem("volume", volume.toString());
                }
              }
            />
          </div>
          <div class="volume-display">
            {Math.floor(volume * 100)}%
          </div>
        </div>

      
      {/if}

    </div>
  </div>
</div>

<style>
  .container {
    max-width: 100%;
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); */
    background-color: #21d4fd;
    /* // background-image: linear-gradient(19deg, #21D4FD 0%, #B721FF 100%); */
    background: linear-gradient(135deg, #742bb0 0%, #4b6cb7 100%);

    color: white;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
  }
  .track-data {
    padding: 20px;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
  }
  .track-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
    text-align: center;
    flex: 1;
    min-width: 0;
  }
  .paper-name {
    font-size: 1em;
    font-weight: 500;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .track-name {
    font-size: 0.8em;
    color: rgba(255, 255, 255, 0.8);
    /* display: none; */
  }
  .controls-container {
    display: flex;
    gap: 20px;
    align-items: center;
  }


  .audio-loading, .audio-error {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }


  .time-control, .volume-control {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .volume-control {
    flex: none;
  }
  .volume-control .position-slider {
    width: 30px;
  }
  .volume-control {
    margin-top: 12px;
  }
  .volume-control .volume-display {
    display: inline-block;
    font-size: 0.5em;
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
    position: relative;
    top: -5px;
  }


  .position-slider {
    width: 100%;
    height: 6px;
    -webkit-appearance: none;
    appearance: none;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 3px;
    outline: none;
  }
  .position-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    background: #00ffff;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s;
  }
  .position-slider::-webkit-slider-thumb:hover {
    transform: scale(1.2);
    box-shadow: 0 0 10px rgba(29, 185, 84, 0.5);
  }
  .time-display, .volume-display {
    display: flex;
    justify-content: space-between;
    font-size: 0.9em;
    color: rgba(255, 255, 255, 0.9);
  }
  .button {
    min-width: 60px;
    height: 60px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1em;
    transition: all 0.2s;
  }
  .play-btn {
    background: #21d4fd;
    color: white;
  }
  .play-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 0 15px #2196f3;
  }
  .play-btn svg {
    pointer-events: none;
  }
  .share-btn {
    background: rgba(255, 255, 255, 0.3);
    color: white;
  }
  .share-btn:hover {
    background: rgba(255, 255, 255, 0.4);
    transform: scale(1.05);
  }
  @keyframes float {
    0% {
      transform: translateY(0) rotate(0deg);
      opacity: 0;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      transform: translateY(-100vh) rotate(360deg);
      opacity: 0;
    }
  }
  .lyrics-container {
    height: 300px;
    overflow-y: auto;
    padding: 40px 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    flex: 1;
    font-size: min(5vw, 32pt);
    background: rgba(255, 255, 255, 0.1);
    scrollbar-color: #00ffff #4b6cb7;
    scrollbar-width: thin;
  }
  .lyric-line {
    padding: 0.5em;
    margin: 0.5em 0;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
    transition: all 0.2s;
    scroll-margin-top: 20vh;
    white-space: nowrap;
  }
  .lyric-line:hover {
    background: rgba(0, 0, 0, 0.1);
  }
  .lyrics-part {
    text-align: center;
    flex: 1;
  }
  .lyrics-part .text {
    color: #222;
    font-weight: 400;
  }
  .lyric-line.next .text {
    color: grey;
    font-size: 110%;
  }
  .lyric-line.next {
    background: rgba(0, 0, 0, 0.1);
  }
  .lyric-line.active .text {
    color: white;
    font-size: 110%;
  }
  @supports (background-clip: text) or (-webkit-background-clip: text) {
    .lyric-line .text {
      background: linear-gradient(to right, white 0%, white 50%, #222 50%, #222 100%);

      -webkit-background-clip: text;
      background-clip: text;

      -webkit-text-fill-color: transparent;
      color: transparent;

      background-size: 201% 100%;
      background-position: 100%;
      transition: background-position 0s linear;
      text-decoration: none;
    }
    .lyric-line.active .text {
      background-position: 0%;
      transition: background-position 0s linear;
    }
    .lyric-line.finished .text {
      background: none;
      -webkit-background-clip: none;
      background-clip: none;
      -webkit-text-fill-color: grey;
      color: grey;
      background-clip: none;
    }
    /*
    .lyric-line.finished .text, .lyric-line.notStarted .text {
      transition: none !important;
    }
    */
  }
  .timestamp {
    width: 3em;
    color: #e0e0e0;
    font-size: 0.5em;
    margin-top: 0.7em;
    display: none;
  }
  .original {
    margin-top: 0.5em;
    font-size: 0.5em;
    font-style: italic;
    opacity: 0.5;
  }
  .time-control {
    margin: 10px 0 0 0;
  }
  .lyric-line.active {
    transition: all 0.2s;
  }
  .lyric-line.active .text {
    color: #ffffff;
    font-weight: 600;
  }
  .header {
    padding: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(5px);
    z-index: 1;
    display: flex;
  }

  .back-button {
    display: flex;
    align-items: center;
    gap: 8px;
    border: none;
    background: none;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    font-size: 16px;
  }

  .back-button:hover {
    color: #fff;
  }
</style>
